import { GitStashEntry } from '../models/git-worker.model';

export function extractStashEntries(stashedChangesStr: string, stashLog: string): GitStashEntry[] {
  if (!stashedChangesStr || !stashLog) {
    return [];
  }
  /**
   * 0000000000000000000000000000000000000000 c434adc4215fd31b746c14da9396406b4edeb657 Name <email> ...
   */
  const stashHashes = stashLog.split('\n').map((logLine) => {
    const parsedResult = /^[0-9a-f]{5,40} ([0-9a-f]{5,40})/.exec(logLine);
    return parsedResult?.[1] ?? '';
  });
  /**
   * stash@{0}: WIP on test: c166b90 Update metadata.json
   * stash@{1}: WIP on kind-of-working: 44606e4 Update metadata.json
   */
  return stashedChangesStr.split('\n').map((stashLine, i) => {
    // extract stash in reflog syntax(stash@{0}) and branch name
    const parsedResult = /^stash@{(\d+)}: WIP on (.+?):/.exec(stashLine);
    return {
      index: parsedResult?.[1] ?? '',
      branchName: parsedResult?.[2] ?? '',
      sha: stashHashes[stashHashes.length - 1 - i] ?? '',
    };
  });
}
